module.exports = __webpack_public_path__ + "img/message.5612f02d.jpg";